// extracted by mini-css-extract-plugin
export default {"agentList":"AgentList_agentList__v4kI0"};